module.exports = __webpack_public_path__ + "../assets/fonts/Neutra2Text-Light.2654cc6d88efe0c13b173b374c118790.otf";